module.exports = __webpack_public_path__ + "static/media/admindashb.aebbb18d.jpg";